/** 图片 */
export const MAX_PHOTOS = 20;
export const MAX_IMAGE_SIZE = 20 * 1024 * 1024; // 20M
export const MAX_IMAGE_SIZE_DISPLAY = `${Math.round(MAX_IMAGE_SIZE / 1024 / 1024)}M`;
export const IMAGE_ACCEPT_FORMAT = 'image/jpg, image/png, image/jpeg';
export const IMAGE_ACCEPT_FORMAT_WITH_GIF = 'image/jpg, image/png, image/jpeg, image/gif';
export const IMAGE_ACCEPT_TAKING_PHOTO = 'image/*';
export const MAX_IMAGE_WIDTH = 10000;
export const MAX_IMAGE_HEIGHT = 10000;
export const IMAGE_ACCEPT_FORMAT_DISPLAY = IMAGE_ACCEPT_FORMAT.replace(/image\//g, '').toUpperCase();
export const IMAGE_ACCEPT_FORMAT_WITH_GIF_DISPLAY = IMAGE_ACCEPT_FORMAT_WITH_GIF.replace(/image\//g, '').toUpperCase();

/** 视频 */
export const MAX_VIDEOS = 20;
export const MAX_VIDEO_SIZE = 2 * 1024 * 1024 * 1024; // 2GB
export const MAX_VIDEO_SIZE_DISPLAY = `${Math.round(MAX_VIDEO_SIZE / 1024 / 1024 / 1024)}GB`;
export const MAX_VIDEO_DURATION = 30 * 60; // 30min
export const MAX_VIDEO_DURATION_DISPLAY = Math.round(MAX_VIDEO_DURATION / 60);
export const VIDEO_ACCEPT_FORMAT = 'video/quicktime, video/wmv, video/wm, video/asf, video/asx, video/rmvb, video/rm, video/ra, video/ram, video/mov, video/3gp, video/mp4, video/mp4v, video/m4v, video/mkv, video/avi, video/flv, video/f4v';
export const VIDEO_ACCEPT_FORMAT_DISPLAY = VIDEO_ACCEPT_FORMAT.replace(/video\//g, '').toUpperCase();
export const VIDEO_CONTAINER_WIDTH = 450;
export const VIDEO_CONTAINER_HEIGHT = 250;
